import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type SubAccountCreationRows = {
  label: string;
  id: vp.SubAccountCreationId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
  type: 'input' | 'select';
  placeholder: string;
  information?: string;
  visible: boolean;
  maxLength?: number;
  getSelectOptions: () => { [key: string]: string };
};

export const buildSubAccountRows = (): SubAccountCreationRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.Create.Form' });
  return [
    {
      label: t('LegalBusinessName.label'),
      id: vp.SubAccountCreationId.LegalBusinessName,
      require: true,
      preset: 'text',
      type: 'input',
      placeholder: t('LegalBusinessName.placeholder'),
      visible: true,
      getSelectOptions: () => ({}),
    },
    {
      label: t('OriginatorName.label'),
      id: vp.SubAccountCreationId.OriginatorName,
      require: true,
      preset: 'text',
      type: 'input',
      placeholder: t('OriginatorName.placeholder'),
      information: t('OriginatorName.information'),
      visible: true,
      maxLength: 30,
      getSelectOptions: () => ({}),
    },
    {
      label: t('OriginatorShortName.label'),
      id: vp.SubAccountCreationId.OriginatorShortName,
      require: true,
      preset: 'text',
      type: 'input',
      placeholder: t('OriginatorShortName.placeholder'),
      information: t('OriginatorShortName.information'),
      visible: true,
      maxLength: 15,
      getSelectOptions: () => ({}),
    },
    {
      label: t('EmailAddress.label'),
      id: vp.SubAccountCreationId.EmailAddress,
      require: true,
      preset: 'text',
      type: 'input',
      placeholder: t('EmailAddress.placeholder'),
      information: t('EmailAddress.information'),
      visible: true,
      getSelectOptions: () => ({}),
    },
  ];
};
